import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, AlertCircle } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLogin = () => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if already logged in
    const isAdmin = localStorage.getItem('idmat_admin');
    if (isAdmin) {
      navigate('/admin/dashboard');
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post(`${API}/admin/login`, { password });
      if (response.data.success) {
        localStorage.setItem('idmat_admin', password);
        navigate('/admin/dashboard');
      }
    } catch (err) {
      setError('Mot de passe incorrect');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#1a1a1a] flex items-center justify-center px-4" data-testid="admin-login">
      <div className="bg-white p-8 md:p-12 w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-[#F5C500] mx-auto mb-4 flex items-center justify-center">
            <Lock size={32} color="#1a1a1a" />
          </div>
          <h1 
            className="text-2xl font-bold text-[#1a1a1a]"
            style={{ fontFamily: 'Barlow Condensed, sans-serif' }}
          >
            Administration IDMAT Service
          </h1>
          <p className="text-gray-500 mt-2">Connectez-vous pour accéder au panneau d'administration</p>
        </div>

        {error && (
          <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 mb-6 flex items-center gap-2">
            <AlertCircle size={20} />
            {error}
          </div>
        )}

        <form onSubmit={handleLogin}>
          <div className="mb-6">
            <label className="block text-sm font-bold text-[#1a1a1a] mb-2 uppercase tracking-wide">
              Mot de passe
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 bg-gray-100 border border-gray-200 focus:border-[#F5C500] focus:outline-none"
              placeholder="Entrez le mot de passe"
              required
              data-testid="admin-password"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#F5C500] text-[#1a1a1a] py-4 font-bold uppercase tracking-wide hover:bg-[#ddb200] transition-colors disabled:opacity-50"
            style={{ fontFamily: 'Barlow Condensed, sans-serif' }}
            data-testid="admin-login-btn"
          >
            {loading ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>

        <p className="text-center text-gray-400 text-sm mt-6">
          <a href="/" className="hover:text-[#F5C500]">← Retour au site</a>
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
